import { Helmet } from "react-helmet";
import { Heading, Img, Button, Text } from "../../components";
import CarCard from "../../components/CarCard";
import UserProfile1 from "../../components/UserProfile1";
import React, { Suspense, useEffect, useState, useCallback, useRef } from "react";
import RightSideMenuProvider from "components/RightSideMenuProvider";
import MyAdsProvider from "components/MyAdsProvider";
import FilterBar from "components/FilterBar";
import AllCarsLines from "components/TestFile1AfterRow";
import axios from "axios";
import { API_DOMAIN_IMG, API_DOMAIN } from 'config';
import { useLocation, useNavigate } from 'react-router-dom';
import CarsTable from "components/CarsTable";
import useDisplayMode from "useDisplayMode";
import useInfiniteScroll from "components/UseInfiniteScroll";
const carTabs = [
  "מודעות חדשות",
    "כל המודעות",
  "מודעות בארכיון",

];

const offerTabs = [
  "הצעות ממתינות לאישור",  "הצעות שאושרו",  "הצעות שנדחו",


];


export default function CarCatalogDealer({ currentUser, setGlobalCounters, setDealerCounters }) {
    const location = useLocation();
    const navigate = useNavigate();

    const getInitialTab = () => {
    const t = location.state?.defaultTab;
return t && carTabs.includes(t) ? t : "מודעות חדשות";
  };
  const [activeTab, setActiveTab] = useState(getInitialTab);
  const [displayMode, setDisplayMode] = useDisplayMode();
  const [filters, setFilters] = useState({});
  const [reload, setReload] = useState(false);
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(() => {
    const urlPage = new URLSearchParams(location.search).get("page");
    return urlPage ? Number(urlPage) : 1;
  });
  const [hasMore, setHasMore] = useState(true);
  const PAGE_SIZE = 8;
  const [actionLoading, setActionLoading] = useState(false);
const appliedDefaultTabRef = useRef(false);
const TAB_FILTERS = {
  "כל המודעות": {},

"מודעות חדשות": {
  withoutOffersOnly: 1,
  approvedOther: 0,
  excludeNotInt: 1
},


  "מודעות בארכיון": {
archiveOnly: 1 

    //includeNotInt: 1,          // להראות “לא מעוניין” (5)
  },
};


const goToOfferTab = (tab) => {
navigate("/my-offers", { state: { defaultTab: tab }, replace: true });
};


  const handleDisplayMode = (mode) => {
    setDisplayMode(mode);
    localStorage.setItem("displayMode", mode);
  };

const sentinelRef = useInfiniteScroll(() => {
  if (loading || actionLoading || !hasMore) return;
  setPage(p => p + 1);
});

const handleCardUpdate = async (carId, newStatus) => {
  setActionLoading(true);

  let needFill = false;

  setCars(prev => {
    const next = prev.filter(c => c.id !== carId);
    needFill = next.length < PAGE_SIZE;
    return next;
  });

  try {
    if (needFill && hasMore) {
      await fetchCars(page + 1, false);
    }
    setReload(v => !v);
  } finally {
    setActionLoading(false);
  }
};




  useEffect(() => {
    const sp = new URLSearchParams(location.search);
    sp.set("page", page);
    window.history.replaceState({}, "", `${location.pathname}?${sp.toString()}`);
  }, [page, location.pathname, location.search]);

  const fetchCars = useCallback(async (pageToLoad = 1, reset = false) => {
    if (!currentUser?.id) return;
    setLoading(true);
    const params = {
      userId: currentUser.id,
      priceMin: filters.priceMin,
      priceMax: filters.priceMax,
      manufacturers: (filters.manufacturers ?? []).join(','),
      models: (filters.models ?? []).join(','),
      years: (filters.years ?? []).join(','),
      carTypes: (filters.carTypes ?? []).join(','),
      accidentTypes: (filters.accidentTypes ?? []).join(','),
      saleTypes: (filters.saleTypes ?? []).join(','),
      ...TAB_FILTERS[activeTab],
      page: pageToLoad,
      pageSize: PAGE_SIZE,
    };
    try {
      const { data } = await axios.get(`${API_DOMAIN}/car/filterCars`, { params });
    
      setCars(prev => reset ? data : [...prev, ...data]);
 setHasMore(data.length === PAGE_SIZE);   // ← השורה החשובה
    } catch (err) {
      console.error("שגיאה בשליפת רכבים:", err);
    } finally {
      setLoading(false);
    }
  }, [currentUser?.id, filters, activeTab]);

useEffect(() => {
  if (actionLoading) return;

  fetchCars(page, page === 1);

  const t = setInterval(() => {
    if (!actionLoading) fetchCars(1, true);
  }, 120000);

  return () => clearInterval(t);
}, [fetchCars, page, actionLoading]);


  useEffect(() => {
    setPage(1);
    fetchCars(1, true);
  }, [filters, activeTab]);

  useEffect(() => {
    if (!currentUser?.id) return;
    const loadCounters = async () => {
      const base = { userId: currentUser.id };
      const count = async (filterObj = {}, clientFilter = null) => {
        const params = Object.fromEntries(
          Object.entries({ ...base, ...filterObj }).map(([k, v]) =>
            Array.isArray(v) ? [k, v.join(",")] : [k, v]
          )
        );
        const { data } = await axios.get(`${API_DOMAIN}/car/filterCars`, { params });
        return clientFilter ? data.filter(clientFilter).length : data.length;
      };
      const all = await count();
      const news = await count(TAB_FILTERS["מודעות חדשות"], c => c.offer_status !== 5);
      const archive = await count(TAB_FILTERS["מודעות בארכיון"], c => [3, 4, 5].includes(c.offer_status));
      setGlobalCounters({ all, new: news, archive });
    };
    loadCounters();
  }, [currentUser?.id, reload, cars.length]);
useEffect(() => {
  if (appliedDefaultTabRef.current) return;

  const t = location.state?.defaultTab;
  if (t && carTabs.includes(t)) {
    setActiveTab(t);
  }

  appliedDefaultTabRef.current = true;
}, [location.key]);
  return (
    <>

      <div className="car-catalog-dealer flex bg-blue_gray-50 p-8 sm:p-4 " style={{paddingTop: '1.2rem'}}>
        <div className="w-[100%] items-start gap-4 md:flex-col" style={{ gap: '2%' }}>
          <div
            className="main-section flex relative flex-1 flex-col gap-8 self-center rounded-[24px] bg-secondary-primary_white p-6 md:self-stretch sm:p-4"
            style={{ minHeight: "95.5vh" }}
          >
            <header className="flex flex-col items-start gap-3">
              <div style={{width: '9%'}} className="ml-3 w-[9%] absolute top-0 left-0 h-8  flex items-center justify-center gap-4 rounded-br-[10px] md:px-5">
                <div className="flex w-full justify-center gap-1">
                  <Heading size="headinglg" as="h2" className="text-[12px] font-bold !text-gray-900_04">
                    <span className="text-gray-900_04">&nbsp;</span>
                    <span className="font-heebo font-medium text-gray-600">רכבים</span>
                  </Heading>
                  <Img src="images/img_signal_red_a700_03_16x16.svg" alt="Signal" className="h-[16px]" />
                </div>
                <div className="flex w-full items-center justify-center">
                  <Heading size="textxs" as="h3" className="!font-heebo text-[12px] font-medium !text-gray-600">
                    סוחר
                  </Heading>
                  <Img src="images/img_vector_deep_orange_500.svg" alt="Image" className="h-[16px]" />
                </div>
              </div>
              <div className="flex items-center justify-between gap-5 mt-5 self-stretch md:flex-col">
<div className="flex w-[6%] justify-center gap-3.5 md:w-full hide-mobile">
  <Img
    src="images/img_button1_gray_100_01.svg"
    alt="Buttonone"
    onClick={() => handleDisplayMode("cards")}
    className="h-[32px] rounded-[10px] cursor-pointer"
  />
  <Img
    src="images/3lines.svg"
    alt="Buttonone"
    onClick={() => handleDisplayMode("lines")}
    className="h-[32px] rounded-[10px] cursor-pointer"
  />

  <div
    onClick={() => handleDisplayMode("lines")}
    className="h-[32px] w-[32px] flex items-center justify-center rounded-[10px] bg-gray-100_03 cursor-pointer"
  >
    <Img
      src="images/img_megaphone_gray_600.svg"
      alt="Megaphone"
      className="h-[12px]"
    />
  </div>
</div>
<div style={{direction: 'rtl'}} className="flex justify-center gap-4 text-base flex-row md:gap-2 md:text-[14px]  border-b border-solid border-gray-200 ">

  {carTabs.map((tab) => (
    <div
      key={tab}
      onClick={() => setActiveTab(tab)}
      className={`cursor-pointer text-center px-4 py-2 md:px-0 md:py-0 ${
        activeTab === tab
          ? "border-b border-red-a700_03 text-black"
          : "text-gray-600"
      }`}
    >
      {tab}
    </div>
  ))}  {offerTabs.map((tab) => (
    <div
      key={tab}
      onClick={() => goToOfferTab(tab)}
      className="cursor-pointer text-center text-gray-600 hover:text-black px-4 py-2 md:px-0 md:py-0"
    >
      {tab}
    </div>
  ))}

</div>

                <div className="flex gap-3">
                  <Heading size="heading9xl" as="h4" className="!font-heebo text-[25px] font-bold lg:text-[21px]">
                    מודעות רכבים
                  </Heading>
                  <Img src="images/img_car_red_a700_03_1.svg" alt="Car" className="icon-mobile h-[36px]" />
                </div>
              </div>
            </header>
            <div className="flex flex-col gap-6">
              <FilterBar onChange={setFilters} />
              {displayMode === "cards" && !loading && (cars?.length ?? 0) === 0 ? (
                <div
                  className="w-full flex-1 flex items-center justify-center"
                  style={{ direction: "rtl", paddingTop: "96px" }}
                >
                  <div className="rounded-[16px] border border-gray-200 bg-white px-10 py-8 flex items-center gap-6">
                    <div className="flex items-center gap-4" style={{ direction: "ltr" }}>
                      <Img src="images/img_car_red_a700_03_1.svg" alt="car" className="h-[28px] w-[28px]" />
                      <div className="flex flex-col items-center text-center" style={{ direction: "rtl" }}>
                        <Heading as="h3" className="!font-assistant text-[16px] font-medium !text-gray-900_04">
                          אין כרגע תוצאות
                        </Heading>
                        <Heading as="h3" className="!font-assistant text-[16px] font-medium !text-gray-900_04">חפש משהו אחר</Heading>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className="grid grid-cols-4 justify-center gap-5 gap-y-5 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1"
                  style={{ direction: "rtl" }}
                >
                  <Suspense fallback={<div>Loading feed...</div>}>
                    {displayMode === "cards" &&
                      cars?.map((car) => (
                        <CarCard key={car.id} currentUser={currentUser} onUpdate={handleCardUpdate} {...car} />
                      ))}
                    <div ref={sentinelRef} style={{ height: 1 }} />
                  </Suspense>
                </div>
              )}

              <div className="flex flex-col gap-2.5">
                {displayMode === "lines" && !loading && (cars?.length ?? 0) === 0 && (
                  <div
                    className="w-full flex items-center justify-center"
                    style={{ direction: "rtl", minHeight: "50vh" }}
                  >
                    <div className="rounded-[16px] border border-gray-200 bg-white px-10 py-8 flex items-center gap-6">
                      <div className="flex items-center gap-4" style={{ direction: "ltr" }}>
                        <Img src="images/img_car_red_a700_03_1.svg" alt="car" className="h-[28px] w-[28px]" />
                        <div className="flex flex-col items-center text-center" style={{ direction: "rtl" }}>
                          <Heading as="h3" className="!font-assistant text-[16px] font-medium !text-gray-900_04">
                            אין כרגע תוצאות
                          </Heading>
                          <Heading as="h3" className="!font-assistant text-[16px] font-medium !text-gray-900_04">חפש משהו אחר</Heading>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {displayMode === "lines" && (cars?.length ?? 0) > 0 && (
                  <>
                    <CarsTable cars={cars} currentUser={currentUser} onUpdate={handleCardUpdate} />
                    <div ref={sentinelRef} style={{ height: 1 }} />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
